import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD, { managers, modules, services } from "../../../../../engines/gameEngine";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { GAME_MODE } from "../../../../../engines/managers/gameContent/gameMode_json";
import {  UI_Z_INDEX } from "../../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
import UserDataManage from "../../../model/UserDataManage";
import { GAME_EVENT, PAGE } from "./Enum";
import InGamePage from "./InGamePage";
import { ILosePagePrams, ITipsPagePrams, IWinPagePrams } from "./Interface";


const { ccclass, property } = cc._decorator;

@ccclass
export default class NormalLevelBase extends BasePopUpLayer {

    protected hadEnd: boolean = false;

    protected inGamePage: InGamePage = null;
    protected m_mode: GAME_MODE = GAME_MODE.NORMAL;
    hasOpenTips: boolean = false;

    protected bShowHint1 = false;
    protected bShowHint2 = false;

    private hintNode: cc.Node = null;
    protected csvInfo: any = null;

    onLoad () {

        O1HD.getModules().uiControlModule.hideLoading();

        this.node.on(cc.Node.EventType.TOUCH_START, this.touchScene, this);
        O1HD.on(GAME_EVENT.GAME_PAUSE, this.pauseGame, this);
        O1HD.on(GAME_EVENT.GAME_RESUME, this.resumeGame, this);
        O1HD.on(GAME_EVENT.ON_TIPS_GOT, this.onGetTip, this);
        O1HD.on(GAME_EVENT.ON_ANSWER_GOT, this.onGetAnswer, this);
    }

    start() {
        let levelId = this._carryData.levelId;
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.THRU_TIME_LEVEL, levelId);
        if (!this.csvInfo) {
            console.error(`未找到数据 THRU_TIME_LEVEL id = ` + levelId);
            return;
        }

        this.inGamePage = this.node.getChildByName('InGamePage').getComponent(InGamePage);
        this.inGamePage.setData(this, this.csvInfo.name);
    }

    OnTips(closeTipsPageCall?: () => void) {
        cc.audioEngine.pauseAll();
        
        this.hasOpenTips = true;
        utilsView.openPopupLayer(
            'prefab/TipsShowPage'
            , BUNDLE_SMALL_NAME.thruTimeAccess
            , this.node
            , {
                onClose: () => {
                    this.hasOpenTips = false;
                    closeTipsPageCall && closeTipsPageCall();
                    this.hintNode = null;
                    cc.audioEngine.resumeAll();
                }
                , bShowHint1: this.bShowHint1
                , bShowHint2: this.bShowHint2
                , strHint: this.csvInfo.first_hint
                , hintIcon: this.csvInfo.second_hint
                , bundleName: this.csvInfo.level_bundle
                , showHint1: ()=> {
                    this.bShowHint1 = true;
                }
                , showHint2: ()=> {
                    this.bShowHint2 = true;
                }
            }
            , null
            , (node)=> {
                this.hintNode = node;
            }
        )
    }

    onGetAnswer() {

    }
    onGetTip() {

    }
    pauseGame() { }

    resumeGame() { }

    touchScene(e: cc.Event.EventTouch) {
        let pos: cc.Vec2 = e.getLocation();
        pos = this.node.convertToNodeSpaceAR(pos);
        // if (mainRoot.UIRoot.getChildByName('clickItem')) {
        //     mainRoot.UIRoot.getChildByName('clickItem').removeFromParent();
        // }
        // let node = cc.instantiate(this.md);
        // node.name = 'clickItem';
        // mainRoot.UIRoot.addChild(node);
        // node.setPosition(pos);
        // node.getComponent(comSpSkeleton).playAnimation("animation").start(false).onComplete(1, () => {
        //     node.removeFromParent();
        // });
    }

    Win(time?: number, jyIndex?: number, userStr?: string) {
        if (this.hadEnd) { return; }
        this.hadEnd = true;

        let delayTime: number = 3.5;
        if (time) {
            delayTime = time;
        }

        let levelId = this._carryData.levelId;
        let csvInfo = this.csvInfo;
        let nextId = this._carryData.nextId;

        let thruTimeDataManage = UserDataManage.instance.thruTimeDataManage;
        let thruTimeData = thruTimeDataManage.thruTimeData;
        let data = thruTimeData.lists.get(levelId);
        let bFirstWin = data.bFirstWin;

        if (data.bFirstWin) {
            data.bFirstWin = false;
            thruTimeData.saveLocalData();
        }

        this.scheduleOnce(async () => {
            managers().soundMgr.stopAllEffects();
            // modules().uiControlModule.ClosePage(PAGE.TIPSPAGE);
            modules().uiControlModule.CloseAllPage();
            managers().soundMgr.playSound('win');
            let winTest = csvInfo.win_hint;
            // if (isUseString) {
            // }
            if (userStr) {
                winTest = userStr;
            }
            let winPrams: IWinPagePrams = {
                mode: this.m_mode,
                winText: winTest,
                index: 0,
                jyInde: jyIndex,
                eventId: bFirstWin ? csvInfo.first_finish : null,
                resetStart: ()=> {
                    this.restartLv();
                },
                onBack: ()=> {
                    this.exitLayer();
                },
            };
            
            let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.thruTimeAccess);
            await modules().uiControlModule.OpenPage(PAGE.WINPAGE, UI_Z_INDEX.DIALOG, winPrams, bundle, true);
            if (nextId) {
                thruTimeData.curSelectLv = nextId;
                thruTimeData.saveLocalData();
                UserDataManage.instance.thruTimeDataManage.openNewLevel(nextId);
            }
        }, delayTime);
    }

    Lose(time?: number) {
        if (this.hadEnd) { return; }
        this.hadEnd = true;
        let delayTime: number = 2;
        if (time) {
            delayTime = time;
        }

        let csvInfo = this.csvInfo;

        let lose_hint = csvInfo.lose_hint;
        this.scheduleOnce(() => {
            managers().soundMgr.stopAllEffects();
            modules().uiControlModule.CloseAllPage();
            managers().soundMgr.playSound('inLevel');
            let losePrams: ILosePagePrams = {
                mode: this.m_mode,
                loseText: lose_hint,
                resetStart: ()=> {
                    this.restartLv();
                },
                onBack: ()=> {
                    this.exitLayer();
                },
                tips: null,
                eventId: csvInfo.lose_event,
                index: 0,
                
            };
            modules().uiControlModule.CloseAllPage();

            let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.thruTimeAccess);
            modules().uiControlModule.OpenPage(PAGE.LOSEPAGE, UI_Z_INDEX.DIALOG,  losePrams, bundle, true);
            // mainRoot.LevelSystem.LoadLevel(mainRoot.LevelSystem.GetSignleLevelInfo(this.m_mode).bundleName, this.m_mode, null, false);
            // mainRoot.UISystem.CloseAllPage();
        }, delayTime);
    }

    nextLv() {
        this.destroyNode();
        O1HD.emit(MessageEventKind.EventName.ENTER_THRU_TIME_LEVEL, this._carryData.idIdx, true);
    }

    restartLv() {
        this.destroyNode();
        O1HD.emit(MessageEventKind.EventName.ENTER_THRU_TIME_LEVEL, this._carryData.idIdx);
    }

    getHasEndGame() {
        return this.hadEnd
    }

    exitLayer() {
        cc.audioEngine.stopAllEffects();
        this.destroyNode();
        O1HD.getManagers().soundMgr.playMusic("hallBgm");
    }

    protected onDestroy(): void {
        
    }
}